<template>

  <v-container fluid class="page page-user-settings">

    <!-- Breadcrumb -->
    <v-row class="mt-4 mb-6">
      <v-col cols="12" class="d-flex align-center justify-start page-breadcrumb-new">
        <v-icon small class="mr-2">mdi-cog</v-icon>
        <div>User Settings</div>
      </v-col>
    </v-row>

    <!-- Page Navigation -->
    <v-tabs left fixed-tabs show-arrows class="mt-4 page-navigation" v-model="activeTab">
      <v-tab @click="$root.goTo('user-settings-profile')">Profile</v-tab>
      <v-tab @click="$root.goTo('user-settings-facility-agent')" v-if="showFacilityAgentSettings">Facility Agent</v-tab>
      <v-tab @click="$root.goTo('user-settings-driver')" v-if="showDriverSettings">Driver</v-tab>
    </v-tabs>

    <!-- Page View -->
    <transition name="fade-flash" mode="out-in">
      <router-view />
    </transition>

  </v-container>

</template>

<script>
export default {
  name: 'UserSettingsRootPage',

  components: {
  },

  data () {
    return {
      activeTab: 0
    }
  },

  computed: {
    showFacilityAgentSettings () {
      return this.$root.uiType() !== 'sys-admin'
    },
    showDriverSettings () {
      return this.$root.activeUserHasRole('driver')
    }
  },

  async beforeMount () {
    // Set active tab
    this.setActiveTab()

    // Load active user to edit
    this.$store.dispatch('auth/setActiveUserToEdit')
  },

  async beforeDestroy () {
    // Clear user editing
    this.$store.dispatch('auth/clearActiveUserEditing')
  },

  methods: {
    setActiveTab () {
      switch (this.$route.name) {
        case 'user-settings-profile': this.activeTab = 0; break
        case 'user-settings-facility-agent': this.activeTab = 1; break
        case 'user-settings-driver': this.activeTab = 2; break
        default: this.activeTab = 0
      }
    }
  }
}
</script>

<style>
  .page-user-settings .label {
    color: #9c9c9c;
    font-size: 1.0rem;
  }

  .page-user-settings .changed-message-text {
    font-size: 1.0rem;
    color: #4CAF50;
    font-weight: 400;
  }

  .page-user-settings .error-text {
    color: #F44336;
    font-size: 1.05rem;
  }

  .page-user-settings .divider {
    border-bottom: 1px solid #525252;
  }
</style>
